import { useState } from "react";
import { Card, Alert } from "antd";
import { CustomMap } from "../../components/maps";

const TestCustomMap = () => {
  const [recintoInfo, setRecintoInfo] = useState<any>(null);
  
  return (
    <div style={{ padding: "24px" }}>
      <Card title="Test CustomMap - Mapa con Buscador y Detector de Recintos SIGPAC">
        {recintoInfo && (
          <Alert
            message="Recinto Seleccionado"
            description={`Provincia: ${recintoInfo.provincia}, Municipio: ${recintoInfo.municipio}, Polígono: ${recintoInfo.poligono}, Parcela: ${recintoInfo.parcela}, Recinto: ${recintoInfo.recinto}`}
            type="success"
            closable
            onClose={() => setRecintoInfo(null)}
            style={{ marginBottom: "16px" }}
          />
        )}
        
        <Alert
          message="Instrucciones"
          description={
            <>
              <strong>Buscador:</strong> Usa el buscador superior para buscar recintos SIGPAC por provincia, municipio, polígono, parcela y recinto.<br/>
              <strong>Detector:</strong> Activa la capa 'Catastro' desde el control de capas (esquina superior derecha) y luego haz click en cualquier punto del mapa para detectar el recinto SIGPAC.
            </>
          }
          type="info"
          style={{ marginBottom: "16px" }}
        />
        
        <CustomMap
          initialCenter={[40.4168, -3.7038]} // Madrid
          initialZoom={12}
          height="700px"
          showLayerControl={true}
          showSearchBar={true}
          onMapReady={(map) => {
            console.log("✅ Mapa CustomMap listo:", map);
          }}
          onRecintoClick={(recintoData) => {
            console.log("🎯 Recinto clickeado:", recintoData);
            setRecintoInfo(recintoData);
          }}
          onRecintoSearch={(recintoData) => {
            console.log("🔍 Recinto buscado:", recintoData);
            setRecintoInfo(recintoData);
          }}
        />
      </Card>
    </div>
  );
};

export default TestCustomMap;
